import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { IntegrityMonitorCustomRuleActionsFormWebComponent } from '../../imCustomRuleActionsForm';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM } from '../../../../../webcomponents.constants';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';
import {
  getIntegrityMonitorRulesRegistryKeyAttributes,
  IntegrityMonitorPlatform,
} from '../../../../common/utils/types';
import { GzHardCodedFormField } from '../../../../../ui/gzForm/formField/component/GzHardCodedFormField';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { IntegrityMonitorInputWithChipsWebComponent } from '../../imCustomRuleInputWithChips/IntegrityMonitorCustomRuleInputWithChipsWebComponent';
import { IMConstants } from '../../../../common/utils/IMConstants';
import { CustomRuleValidators } from '../../common/validators';

export class IntegrityMonitorRegsitryKeyRuleFormView extends BaseWebComponentView {
  public formGroup: FormGroup;

  public dom: {
    $securitySubtitle: GzTitleWebComponent;

    $keyFormField: GzFormFieldWebComponent<IntegrityMonitorInputWithChipsWebComponent, string[]>;

    $actionsForm: IntegrityMonitorCustomRuleActionsFormWebComponent;
  };

  getDomElements() {
    this.dom = {
      $securitySubtitle: this.shadow.querySelector('#security-subtitle'),

      $keyFormField: this.shadow.querySelector('#key-form-field'),

      $actionsForm: this.shadow.querySelector(WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM),
    };

    this.getTranslations();
    this.setTranslatedStrings();
    this.createFormGroup();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getIntegrityMonitorStrings().integrityMonitorRules.customRuleForm;
  }

  setTranslatedStrings() {
    this.dom.$securitySubtitle.innerText = this.translations.securitySubtitle;

    this.dom.$keyFormField.label = this.translations.entityTypeRegistryKey.keyLabel;
    this.dom.$keyFormField.Input.placeholder = this.translations.entityTypeRegistryKey.keyPlaceholder;
  }

  createFormGroup() {
    this.dom.$keyFormField.Validators = [
      CustomRuleValidators.atLeastOneValidator(this.translations.entityTypeRegistryKey.errorAtLeastOneKey),
      CustomRuleValidators.atMostValidator(
        IMConstants.INTEGRITY_MONITOR_RULE_REGISTRYKEY_MAX_ALLOWED_KEYS,
        this.translations.entityTypeRegistryKey.errorTooManyKeys
      ),
    ];

    this.dom.$keyFormField.Input.maxValues = IMConstants.INTEGRITY_MONITOR_RULE_REGISTRYKEY_MAX_ALLOWED_KEYS;

    this.dom.$keyFormField.Input.validator = CustomRuleValidators.registryKeyValidator(
      this.translations.validationErrors
    );

    this.dom.$keyFormField.Input.translations = this.translations.validationErrors;

    this.dom.$keyFormField.initialValue = [];

    this.formGroup = FormGroup.build({
      os: new GzHardCodedFormField<number>(IntegrityMonitorPlatform.WINDOWS),
      registryKeys: this.dom.$keyFormField,
    });
  }

  buildSuccessView(data: any) {
    this.dom.$actionsForm.injectDependencies(this.dependencies);
    this.dom.$actionsForm
      .start()
      .catch(console.warn)
      .then(() => {
        this.dom.$actionsForm.options = getIntegrityMonitorRulesRegistryKeyAttributes(this.dependencies.translateFn);
        this.formGroup.addFormChild(['attributes'], this.dom.$actionsForm.controller.view.formGroup);
      });
  }
}
